<template>
  <div class="box">
    <div class="attendanceContainer px-2">
      <div class="main-box mt-2 px-2">
        <att-header v-if="isAdmin" class="customize-tab-style"></att-header>
      </div>
      <div class="record-box">
        <calendar
          :nowMonth="fromatMonth"
          :posttype="target.posttype"
          @calenList="calenList"
        >
          <p slot="top" class="month" @click="showMonth = !showMonth">
            {{ fromatMonth }} <span :class="{ up: showMonth }"></span>
          </p>
          <div slot="content">
            <div class="main-box mt-2 " v-if="attendance && Object.keys(attendance).length">
              <div class="person-info pt-3 pb-2">
                <!-- <div>
                  <div
                    class="img-box"
                    :style="{
                      backgroundImage: 'url(' + target.avatar + ')',
                    }"
                  >
                    <img :src="target.avatar" alt="" />
                  </div>
                  <p>{{ target.name }}</p>
                </div> -->
              </div>
              <div class="detail-content mt-4 pt-2 px-2"  >
                <div v-if="attendance.FTWT" >
                  <dl>
                    <dd>有效出勤数</dd>
                    <dt>
                      <span>{{ Number(attendance.FTWT).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.O001" >
                  <dl>
                    <dd>平时加班</dd>
                    <dt>
                      <span>{{ Number(attendance.O001).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.O002">
                  <dl>
                    <dd>周末加班(计薪)</dd>
                    <dt>
                      <span>{{ Number(attendance.O002).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.ABST">
                  <dl>
                    <dd>旷工时数(计薪)</dd>
                    <dt>
                      <span>{{ Number(attendance.ABST).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.O003">
                  <dl>
                    <dd>平时加班(调休)</dd>
                    <dt>
                      <span>{{ Number(attendance.O003).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.O004">
                  <dl>
                    <dd>周末加班(调休)</dd>
                    <dt>
                      <span>{{ Number(attendance.O004).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L003">
                  <dl>
                    <dd>调休假</dd>
                    <dt>
                      <span>{{ Number(attendance.L003).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L015">
                  <dl>
                    <dd>出差</dd>
                    <dt>
                      <span>{{ Number(attendance.L015).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L002">
                  <dl>
                    <dd>年假</dd>
                    <dt>
                      <span>{{ Number(attendance.L002).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L005">
                  <dl>
                    <dd>病休假</dd>
                    <dt>
                      <span>{{ Number(attendance.L005).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L001">
                  <dl>
                    <dd>事假</dd>
                    <dt>
                      <span>{{ Number(attendance.L001).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L004">
                  <dl>
                    <dd>病假</dd>
                    <dt>
                      <span>{{ Number(attendance.L004).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L006">
                  <dl>
                    <dd>丧假</dd>
                    <dt>
                      <span>{{ Number(attendance.L006).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L006">
                  <dl>
                    <dd>婚假</dd>
                    <dt>
                      <span>{{ Number(attendance.L006).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L007">
                  <dl>
                    <dd>产假</dd>
                    <dt>
                      <span>{{ Number(attendance.L007).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L009">
                  <dl>
                    <dd>陪产假</dd>
                    <dt>
                      <span>{{ Number(attendance.L009).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L013">
                  <dl>
                    <dd>哺乳假</dd>
                    <dt>
                      <span>{{ Number(attendance.L013).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L014">
                  <dl>
                    <dd>工间假</dd>
                    <dt>
                      <span>{{ Number(attendance.L014).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
                <div v-if="attendance.L012">
                  <dl>
                    <dd>探亲假</dd>
                    <dt>
                      <span>{{ Number(attendance.L012).toFixed(1) }}</span
                      >小时
                    </dt>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </calendar>
      </div>
      <!-- <div class="holiday mt-2" v-if="holiday.length != 0" @click="toLink"> -->
      <div class="holiday mt-2 p-4" v-if="holiday.length != 0">
        <!-- 当前剩余调休<span>{{ holiday.ot_bal }}</span
      >小时，当前剩余年假<span>{{ holiday.leave_bal }}</span
      >小时，当前剩余带薪病假<span>{{ holiday.sick_bal }}</span
      >小时 -->
        <p>
          <span>当前剩余</span>
          <span @click="toHolidayDetail"
            >查看详情<van-icon name="arrow"
          /></span>
        </p>
        <div>
          <dl>
            <dt>
              <span v-if="holiday.leave_bal">{{ parseInt(holiday.leave_bal) }}</span>
              <span v-else>0</span>小时
            </dt>
            <dd>剩余年假</dd>
          </dl>
          <dl>
            <dt>
              <span v-if="holiday.ot_bal">{{ parseInt(holiday.ot_bal) }}</span>
              <span v-else>0</span>小时
            </dt>
            <dd>调休时间</dd>
          </dl>
          <dl>
            <dt>
              <span v-if="holiday.sick_bal">{{ parseInt(holiday.sick_bal) }}</span>
              <span v-else>0</span>小时
            </dt>
            <dd>带薪病假</dd>
          </dl>
        </div>
      </div>
      <div class="holiday mt-2 p-4">
        <p style="font-size: 16px;">
         当天考勤需要次日10点后完成同步（周末及节假日顺延）
        </p>
      </div>

      <van-popup class="month-box" v-model="showMonth" round position="bottom">
        <van-datetime-picker
          v-model="nowMonth"
          type="year-month"
          :formatter="formatter"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="comfirmDateTime"
          @cancel="showMonth = false"
        />
      </van-popup>
      <!-- <float-btn
      v-if="showSend"
      class="send-btn"
      :actionList="actionList"
      @action="doAction"
      :more="false"
    ></float-btn> -->
    </div>
  </div>
</template>

<script>
import calendar from "@/components/attendance/calendar.vue";
// import FloatBtn from "@/components/space/floatBtn.vue";
import AttHeader from "@/components/attendance/att-header.vue";
import api from "@/apis";
import utils from "@/utils/utils";
export default {
  name: "attendance",
  components: { calendar, AttHeader },
  data() {
    return {
      isAdmin: false,
      holiday: [],
      target: {},
      nowMonth: new Date(),
      fromatMonth: utils.formatDate(new Date().getTime() / 1000, "yyyy-MM"),
      showMonth: false,
      minDate: new Date("1970/1/1"),
      maxDate: new Date(),
      showSend: false,
      actionList: [
        {
          icon: require("@/assets/salary/send.png"),
          active: require("@/assets/salary/send.png"),
          type: "send",
          name: "推送",
        },
      ],
      attendance: {},
    };
  },
  created() {
    this.getUserinfo();
    this.atSendAuth();
    this.holidayBalance();
  },
  mounted() {
    if (this.$route.query.month) {
      this.fromatMonth = this.$route.query.month;
    }
  },
  methods: {
    //跳转到考勤详情
    toHolidayDetail() {
      this.$router.push({
        name: "holidayDetail",
        query: {
          month: this.fromatMonth,
        },
      });
    },
    //获取考勤数据
    calenList(data) {
      this.attendance = data;
    },
    //跳转
    toLink() {
      location.href =
        "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1653025162755#/req?iscreate=1&workflowid=550";
    },
    //获取假期余额
    holidayBalance() {
      api.holidayBalance().then((res) => {
        this.holiday = res.data;
      });
    },
    //获取考勤权限
    atSendAuth() {
      api.atSendAuth().then((res) => {
        this.showSend = res.data == 1;
      });
    },
    //推送考勤数据
    sendInfo() {
      this.$dialog
        .confirm({
          message: "确定推送消息吗",
        })
        .then(() => {
          // on confirm
          api
            .atSendReport()
            .then(() => {
              this.$notify({
                type: "success",
                message: "推送成功",
              });
            })
            .catch((err) => {
              this.$notify({
                type: "error",
                message: err.msg,
              });
            });
        })
        .catch(() => {
          // on cancel
        });
      return;
    },
    doAction(e) {
      switch (e) {
        case "send":
          this.sendInfo();
          break;
        default:
          break;
      }
    },
    //选择时间
    comfirmDateTime(e) {
      this.fromatMonth = utils.formatDate(e.getTime() / 1000, "yyyy-MM");
      this.showMonth = false;
      console.log(this.fromatMonth,'calendar-top');

    },
    //格式化时间
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      }
      if (type === "month") {
        return `${val}月`;
      }
      if (type === "day") {
        return `${val}日`;
      }
      if (type === "hour") {
        return `${val}时`;
      }
      return val;
    },
    //获取用户信息
    getUserinfo() {
      api.getUserinfo().then((res) => {
        this.target = res.data;
        this.isAdmin = res.data.is_admin == 1;
      });
    },
    //跳转到考勤统计
    showStatistics() {
      this.$route.push({
        path: "/statistics",
        query: {
          month: 4,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .attendanceContainer {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .attendanceContainer {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.attendanceContainer {
  // @include container();
  min-height: 100vh;
  &::v-deep .van-popup--bottom {
    // width: 750px;
    left: 50%;
    transform: translateX(-50%);
  }
  &::v-deep .send-btn {
    width: 130px;
    height: 130px;
    overflow: auto;
    border-radius: 0;
    .img-box {
      box-shadow: none;
      background-size: contain;
      border-radius: 0;
    }
  }
  .customize-tab-style {
    ::v-deep p {
      height: 72px;
      line-height: 72px;
    }
    ::v-deep .active {
      position: relative;
      z-index: 1;
      height: 72px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 72px;
      &::after {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        z-index: -1;
        width: 184px;
        height: 72px;
        background: linear-gradient(90deg, #69b299 0%, #4da27b 100%);
        box-shadow: 6px 8px 2px 0px rgba(16, 201, 103, 0.14);
        border-radius: 0px 20px 20px 20px;
      }
    }
  }
  .main-box {
    background: #ffffff;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    padding-bottom: 15px;
    .detail-content {
      @include flex-start();
      flex-wrap: wrap;
      position: relative;
      width: 100%;
      &::after {
        content: "";
        height: 0px !important;
      }
      & > div {
        font-size: 28px;
        font-family: SimHei;
        font-weight: 400;
        color: #1e1e1e;
        margin: 12px 0px;
        width: 33%;
        padding-top: 10px;
        dt {
          text-align: center;
          // margin-bottom: 5px;
          span {
            font-size: 26pt;
          }
        }
        dd {
          text-align: center;
        }
      }
    }
    .mt-4 {
      margin-top: -40px;
    }
  }
  .record-box {
    p {
      margin-left: 15px;
      font-size: 34px;
      font-family: SimHei;
      font-weight: 400;
      color: #1e1e1e;
      span {
        margin-left: 10px;
        display: inline-block;
        // border: 1px solid #008854;
        border-radius: 6px;
        padding: 4px 10px;
        text-align: center;
        font-size: 20px;
        font-family: SimHei;
        color: #008854;
      }
    }
    .month {
      width: 180px;
      height: 48px;
      background: #ffffff;
      border-radius: 8px;
      font-size: 26px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #4f4f4f;
      line-height: 48px;
      text-align: center;
      margin-bottom: 15px;
      @include flex-center();
      & > span {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url("~@/assets/arrow-down.png") no-repeat;
        background-size: 100% 100%;
      }
      & > .up {
        transform: rotate(180deg);
      }
    }
  }
  .person-info {
    @include flex-between();
    // border-bottom: 1px solid #dedede;
    padding-top: 10px;

    & > div {
      @include flex-start();
      align-items: center;
      padding-left: 15px;
      .img-box {
        width: 42pt;
        height: 42pt;
        border-radius: 50%;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center center;
        & > img {
          width: 100%;
          height: 100%;
          opacity: 0;
        }
        & > p {
          font-size: 16pt;
        }
      }
    }
  }
  .holiday {
    // cursor: pointer;
    margin: 25px auto;
    font-size: 24px;
    font-family: MiSans;
    color: #1e1e1e;
    width: 100%;
    // height: 120px;
    background: #ffffff;
    border-radius: 8px;
    // line-height: 54px;
    // text-align: center;
    position: relative;
    & > span {
      color: #3a87f6;
    }
    p:nth-child(1) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12pt;
      color: rgba(150, 155, 158, 1);
      margin-bottom: 20px;
      span:nth-child(1) {
        font-weight: 400;
        font-size: 16pt;
        color: rgba(0, 0, 0, 1);
      }
      span:nth-child(2) {
        cursor: pointer;
      }
    }
    div {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      dl {
        dt {
          color: rgba(150, 155, 158, 1);
          span {
            color: rgba(40, 43, 50, 1);
            font-size: 22pt;
          }
        }
        dd {
          color: rgba(40, 43, 50, 1);
          text-align: center;
        }
      }
    }
    // &::after {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   top: -16px;
    //   left: 50%;
    //   transform: translateX(-50%);
    //   width: 0;
    //   height: 0;
    //   border-left: 16px solid transparent;
    //   border-right: 16px solid transparent;
    //   border-bottom: 20px solid #ffffff;
    // }
  }
}



</style>
